import { FormContainer, FormContainerStepProps } from 'components';
import { useTranslation } from 'libs/i18n';
import { FileType, FileUpload } from 'libs/ui';

import {
  IdentityDocumentFormType,
  FormErrors,
  Field,
  getSchema,
  MAX_FILES,
} from '../../forms/identityDocumentForm';

interface Props extends FormContainerStepProps {
  initialValues?: IdentityDocumentFormType;
  canGoBack?: boolean;
  formError?: FormErrors;
  submitLoading?: boolean;
  submitDisabled?: boolean;
  files?: FileUpload[];
  onGoBack?: () => void;
  onSubmit: (values: IdentityDocumentFormType) => void;
  onAddFiles?: (file: File[]) => void;
  onRemoveFile?: (file: FileUpload, index: number) => void;
}

export const IdentityDocument = ({
  initialValues,
  canGoBack,
  submitLoading,
  submitDisabled,
  formError,
  files,
  step,
  onGoBack,
  onAddFiles,
  onRemoveFile,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t('onboarding.legalClientFirstHead.identityDocument.subtitle')}
      title={t('onboarding.legalClientFirstHead.identityDocument.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <Field.FilesUpload
        files={files}
        fileTypes={[FileType.pdf]}
        maxFiles={MAX_FILES}
        name="fileIds"
        title={t(
          'onboarding.legalClientFirstHead.identityDocument.documentTitle'
        )}
        onAddFiles={onAddFiles}
        onRemoveFile={onRemoveFile}
      />
    </FormContainer>
  );
};
